import type { OnboardingDraft } from './types';
import { DEFAULT_EXPERIENCE_LEVEL, DEFAULT_JOB_INDUSTRY } from '../Prompts/promptsV2RolePrompts';

export type OnboardingRoleMeta = {
  jobTitle: string;
  jobIndustry: string;
  level: string;
};

export function resolveOnboardingRoleMeta(
  targetRole: string,
  draft: OnboardingDraft,
  sessionUser: Record<string, unknown> | null
): OnboardingRoleMeta {
  const years = draft.yearsOfExperience;
  let level = String(
    draft.level ||
      sessionUser?.level ||
      sessionUser?.promptLevel ||
      sessionUser?.experienceLevel ||
      ''
  ).trim();

  if (!level && years != null && !Number.isNaN(Number(years))) {
    const rounded = Number(years);
    if (rounded < 2) level = 'Junior';
    else if (rounded < 5) level = 'Mid-level';
    else if (rounded < 10) level = 'Senior';
    else level = 'Lead';
  }
  if (!level) level = DEFAULT_EXPERIENCE_LEVEL;

  const jobIndustry =
    String(
      draft.jobIndustry || sessionUser?.jobIndustry || sessionUser?.industry || DEFAULT_JOB_INDUSTRY
    ).trim() || DEFAULT_JOB_INDUSTRY;

  return {
    jobTitle:
      targetRole.trim() ||
      String(draft.targetRole || draft.currentJobTitle || '').trim() ||
      'Professional',
    jobIndustry,
    level,
  };
}
